import { jwtDecode } from 'jwt-decode'

type ProjectKeyJwtPayload = {
  kid?: string
  [key: string]: unknown
}

/** Reads `kid` from a gateway project-key JWT (unsigned decode, same claim as backend). */
export function parseProjectKeyIdFromGatewayCredential(credential: string | null | undefined): string | null {
  const trimmed = credential?.trim()
  if (!trimmed) {
    return null
  }

  const segments = trimmed.split('.')
  if (segments.length !== 3) {
    return null
  }

  try {
    const payload = jwtDecode<ProjectKeyJwtPayload>(trimmed)
    const payloadKid = payload.kid?.trim()
    if (payloadKid) {
      return payloadKid
    }
  } catch {
    // fall through to header kid
  }

  try {
    const headerPart = segments[0]
    if (!headerPart) {
      return null
    }
    const headerJson = Buffer.from(headerPart, 'base64url').toString('utf8')
    const header = JSON.parse(headerJson) as { kid?: string }
    const headerKid = header.kid?.trim()
    return headerKid || null
  } catch {
    return null
  }
}
